import React from 'react';
import { Typography } from '@mui/material';

const Contact = () => {

    return (
        <div>
            <Typography variant="h3" sx={{ mb: 3, marginTop: 1}} textAlign="center">
                Credits & Contacts
            </Typography>
            <Typography variant="h4" sx={{ mb: 1 }} textAlign="center">
                Virginia Tech Spring 2023 HCI Capstone Group 5:
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Ross Shaffer (rossgshaffer@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Jordan Rudman (jrud25@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Karthik Nair (nairks01@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 2 }} textAlign="center">
                Kevin Yang (keviny@vt.edu)
            </Typography>
            <Typography variant="h4" sx={{ mb: 1 }} textAlign="center">
                Advisors:
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Dr. Scott McCrickard (dmccrick@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Yusheng Cao (cyschris@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Morva Saaty (morvasaaty@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Jixiang Fan (jfan12@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Jaitun Vijaybhai Patel (jaitunvijaybhai@vt.edu)
            </Typography>
            <Typography variant="h5" sx={{ mb: 1 }} textAlign="center">
                Mary Frazier (mcf712@vt.edu)
            </Typography>
        </div>
    );
};

export default Contact;
